import config from './config';

const awsmobile = {
  ...config
};

export default awsmobile;
